export default "__VITE_ASSET__B2KBK7GG__"